import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPurgeControl extends Layout {
    checkboxIsEnabled: Checkbox;
    checkboxIsEnabledSecondaries: Checkbox;
    sourcePurgeControl: DataSource;
    textboxCompanyId: Textbox;
    textboxGranularity: Textbox;
    textboxId: Textbox;
    textboxLastRun: Textbox;
    textboxPurgeClass: Textbox;
    textboxPurgeTime: Textbox;
}
